module.exports = __webpack_public_path__ + "static/powered-0b728ec213d4ac2bbbabb9feb8c3adfb.png";